import { render, staticRenderFns } from "./PostEvent.vue?vue&type=template&id=1310404c&"
import script from "./PostEvent.vue?vue&type=script&lang=js&"
export * from "./PostEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports